import axios from "axios";
import { baseUrl } from "../utils/config.js";

const getAbout = async () => {
  const response = await axios.get(`${baseUrl}/about?populate=*`);
  return response.data.data;
};

export default { getAbout };
